const IFRAME_URL = process.env.REACT_APP_IFRAME_URL
const CLIENT_ID = process.env.REACT_APP_PARTNERS_API_CLIENT_ID
const CLIENT_SECRET = process.env.REACT_APP_PARTNERS_API_CLIENT_SECRET

export default {
  IFRAME_URL,
  CLIENT_ID,
  CLIENT_SECRET,
}
